// extracted by mini-css-extract-plugin
module.exports = {"channelGrid":"PopularChannelsModal_channelGrid__kl29H","channelItem":"PopularChannelsModal_channelItem__MzV0j","tabDescription":"PopularChannelsModal_tabDescription__eCBX3"};